import React, { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageContext } from './AdminLayout';
import { FiFilter, FiRotateCw, FiPlus, FiSearch, FiChevronDown, FiX, FiTrash2 } from "react-icons/fi";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import { es } from 'date-fns/locale';
import check from "../../assets/check.svg";
import { useNavigate } from 'react-router-dom';
import { addShipment, getTeamMembers, getAllShipment, getShipment, updateShipmentDetails, getShippingLineList, addDispatchShipment } from '../../ApiController/ApiService';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import UpdateSealNumberModal from './UpdateSealNumberModal';
import { useDashboard } from '../Context/Dashboardcontext';
import CreateContainerModal from '../OrderContainers/CreateOrderModal';

// Fix Leaflet marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png',
});

const statusColors = {
  'In Transit': 'bg-blue-500',
  'Delivered': 'bg-green-500',
  'Delayed': 'bg-red-500',
  'Pending': 'bg-yellow-400',
};

const TotalPendingContainer = () => {
  const { t } = useTranslation();
  const { selectedLanguage } = useContext(LanguageContext);
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const dropdownRef = useRef(null);
  const dropdownRef2 = useRef(null);
  const calendarRef = useRef(null);
  const buttonRef = useRef(null);
  const buttonRef2 = useRef(null);
  const buttonRef3 = useRef(null);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedShipmentId, setSelectedShipmentId] = useState(null);
  const [selectedTab, setSelectedTab] = useState('Import');
  const [showDropdowns, setShowDropdowns] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [filteredDrivers, setFilteredDrivers] = useState([]);
  const [selectedShipping, setSelectedShipping] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [loadingDrivers, setLoadingDrivers] = useState(false);
  const [driverError, setDriverError] = useState('');

  // --- UPDATED FORM DATA STATE ---
  const [formData, setFormData] = useState({
    importExportType: 'import',
    orderId: '',
    origin: '',
    originLat: '',
    originLng: '',
    destination: '',
    destinationLat: '',
    destinationLng: '',
    description: '',
    goodsType: '',
    pickUpDate: '',
    dropOffDate: '',
    pickUpHours: '',
    dropOffHours: '',
    companyType: "Dispax",

    // Array for multiple containers
    containers: [
      {
        containerNumber: '',
        containerType: '',
        sealNumber: '',
        weight: '',
        noOfPallets: '',
        containerComments: ''
      }
    ],

    length: '',
    // removed single weight/pallet fields from root to use inside containers array
    commodity: '',
    intermediateDestinations: [{ destination: '', time: '', lat: '', lng: '' }],
    terminal: '',
    routeNotes: '',
    driverId: '',
    vehicleNumber: '',
    driverContactNumber: '',
    currentLocation: { type: 'Point', coordinates: [0, 0] },
    destinationLocation: { type: 'Point', coordinates: [0, 0] },
    addOnDate: '',
    estimateDeliveryDate: '',
    portName: '',
    ticketNumber: '',
    bookingNumber: '',
    sl: '',
    price: '',
    isTracking: true,
    status: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState(null);
  const [shipments, setShipments] = useState([]);
  const [allShipmentsForFilters, setAllShipmentsForFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const [uniqueLocations, setUniqueLocations] = useState([]);
  const [uniqueStatuses, setUniqueStatuses] = useState([]);
  const [showMapModal, setShowMapModal] = useState(false);
  const [mapType, setMapType] = useState('');
  const [mapIndex, setMapIndex] = useState(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [showSealModal, setShowSealModal] = useState(false);
  const [shippingLines, setShippingLines] = useState([]);

  const [showLTLModal, setShowLTLModal] = useState(false);
  const [showFTLModal, setShowFTLModal] = useState(false);

  const { userProfile } = useDashboard();

  const [formDatas, setFormDatas] = useState({
    // General fields
    companyType: "Dispax",
    importExportType: 'import',
    orderId: '',
    origin: '',
    originLat: '',
    originLng: '',
    destination: '',
    destinationLat: '',
    destinationLng: '',
    description: '',
    noOfPallets: '',
    weightInTons: '',
    goodsType: '',
    pickUpDate: '',
    dropOffDate: '',
    pickUpHours: '',
    dropOffHours: '',
    containerType: '',
    containerComments: '',
    containerNumber: '',
    length: '',
    weight: '',
    commodity: '',
    terminal: '',
    routeNotes: '',
    driverId: '',
    vehicleNumber: '',
    driverContactNumber: '',
    currentLocation: { type: 'Point', coordinates: [0, 0] },
    destinationLocation: { type: 'Point', coordinates: [0, 0] },
    addOnDate: '',
    estimateDeliveryDate: '',
    portName: '',
    ticketNumber: '',
    price: '',
    isTracking: true,
    status: '',

    // Nested structured fields
    ltl: {
      shippingMethod: '',
      shippingMethod1: '',
      pickEmpty: '',
      sl: '',
      size: '',
      loadDate: '',
      loadTime: '',
      loadAddress: '',
      commodity: '',
      returnFull: '',
      trailerNumber: '',
      bookingNumber: '',
      destination: '',
      pinNumber: '',
      importLocation: '',
      poNumber: '',
      sealNumber: '',
      flatBeds: '',
      dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '', stopType: '' }],
    },
    ftl: {
      shippingMethod: '',
      shippingMethod1: '',
      pickEmpty: '',
      sl: '',
      size: '',
      loadDate: '',
      loadTime: '',
      loadAddress: '',
      commodity: '',
      sealNumber: '',
      returnFull: '',
      trailerNumber: '',
      bookingNumber: '',
      destination: '',
      pinNumber: '',
      importLocation: '',
      poNumber: '',
      flatBeds: '',
      dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '', stopType: '' }],
    },
    export: {
      sl: '',
      loadDate: '',
      loadTime: '',
      loadAddress: '',
      destination: '',
      dispatchMode: '',
      containers: [
        {
          bookingNumber: '',
          size: '',
          pickEmpty: '',
          commodity: '',
          returnFull: '',
        },
      ],
      intermediateDestinations: [{ destination: '', time: '' }],
    },
    import: {
      sl: '',
      size: '',
      pinNumber: '',
      importLocation: '',
      poNumber: '',
      loadDate: '',
      loadTime: '',
      loadAddress: '',
      destination: '',
      commodity: '',
      returnFull: '',
      dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '' }],
    },
  });

  // --- NEW HANDLER FUNCTIONS FOR MULTIPLE CONTAINERS ---

  const handleContainerChange = (e, index) => {
    const { name, value } = e.target;
    const updatedContainers = [...formData.containers];
    updatedContainers[index][name] = value;
    setFormData({ ...formData, containers: updatedContainers });
  };

  const addContainerRow = () => {
    if (formData.containers.length < 20) {
      setFormData({
        ...formData,
        containers: [
          ...formData.containers,
          {
            containerNumber: '',
            containerType: '',
            sealNumber: '',
            weight: '',
            noOfPallets: '',
            containerComments: ''
          }
        ]
      });
    } else {
      toast.warning(t('orders.maxLimitReached') || "Max 20 containers allowed");
    }
  };

  const removeContainerRow = (index) => {
    if (formData.containers.length > 1) {
      const updatedContainers = formData.containers.filter((_, i) => i !== index);
      setFormData({ ...formData, containers: updatedContainers });
    }
  };

  // --------------------------------------------------------

  const handleViewShipment = async (id) => {
    try {
      setModalLoading(true);
      setModalError(null);
      const shipmentData = await getShipment(id);
      setSelectedShipment(shipmentData);
      setFormData({
        ...formData, // keep existing structure
        Id: shipmentData.Id || '',
        orderId: shipmentData.orderId || '',
        noOfPallets: shipmentData.noOfPallets || '',
        goodsType: shipmentData.goodsType || '',
        addOnDate: shipmentData.addOnDate ? new Date(shipmentData.addOnDate).toISOString().slice(0, 16) : '',
        estimateDeliveryDate: shipmentData.estimateDeliveryDate ? new Date(shipmentData.estimateDeliveryDate).toISOString().slice(0, 16) : '',
        store: shipmentData.store || '',
        estimatedTimeAccurate: shipmentData.estimatedTimeAccurate || '',
        status: shipmentData.status || '',
        intermediateDestinations: shipmentData.intermediateDestinations?.length > 0
          ? shipmentData.intermediateDestinations
            .map((stop) => `${stop.destination} - ${new Date(stop.time).toLocaleString(selectedLanguage === 'Spanish' ? 'es-ES' : 'en-US')}`)
            .join('\n')
          : '',
      });
      setShowModal2(true);
    } catch (err) {
      setModalError(t('errors.fetchShipmentDetailsFailed'));
    } finally {
      setModalLoading(false);
    }
  };

  const handleUpdateShipment = async (e) => {
    e.preventDefault();
    try {
      setModalLoading(true);
      setModalError(null);

      const requiredFields = ['Id', 'orderId', 'noOfPallets', 'goodsType', 'addOnDate', 'estimateDeliveryDate', 'status'];
      for (const field of requiredFields) {
        if (!formData[field]) {
          throw new Error(t('errors.requiredField', { field: t(`orders.${field}`) }));
        }
      }

      let intermediateDestinations = [];
      if (formData.intermediateDestinations && typeof formData.intermediateDestinations === 'string') {
        try {
          const lines = formData.intermediateDestinations.split('\n').filter(line => line.trim());
          intermediateDestinations = lines.map(line => {
            const [destination, time] = line.split(' - ').map(s => s.trim());
            if (!destination || !time) throw new Error(t('errors.invalidStopFormat'));
            return { destination, time: new Date(time).toISOString() };
          });
        } catch (err) {
          throw new Error(t('errors.invalidStopFormat'));
        }
      }

      const updateData = {
        Id: formData.Id,
        orderId: formData.orderId,
        noOfPallets: formData.noOfPallets,
        goodsType: formData.goodsType,
        addOnDate: formData.addOnDate,
        estimateDeliveryDate: formData.estimateDeliveryDate,
        store: formData.store || undefined,
        estimatedTimeAccurate: formData.estimatedTimeAccurate || undefined,
        status: formData.status,
        intermediateDestinations: intermediateDestinations.length > 0 ? intermediateDestinations : undefined,
      };

      await updateShipmentDetails(selectedShipment._id, updateData);
      const shipmentData = await getAllShipment({ page: currentPage, limit: 10 ,status:"Pending"});
      setShipments(shipmentData.docs || []);

      setTotalPages(shipmentData.totalPages || 1);
      setTotalDocs(shipmentData.totalDocs || 0);
      setHasPrevPage(shipmentData.hasPrevPage || false);
      setHasNextPage(shipmentData.hasNextPage || false);

      setShowModal2(false);
      setSelectedShipment(null);
      // Reset form data...
    } catch (err) {
      setModalError(t('errors.error', { message: err.message }));
    } finally {
      setModalLoading(false);
    }
  };

  const handleInputChange2 = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const fetchDrivers = async () => {
      setLoadingDrivers(true);
      setDriverError('');
      try {
        const rawDrivers = await getTeamMembers();
        if (!Array.isArray(rawDrivers)) {
          throw new Error(t('errors.unexpectedApiResponse'));
        }
        const formattedDrivers = rawDrivers
          .filter((member) => member.userType?.toLowerCase() === 'driver')
          .map((member) => ({
            id: member._id,
            name: member.fullName || t('orders.unnamedDriver'),
            avatar: member.image || '/path/to/default-avatar.jpg',
          }));
        if (formattedDrivers.length === 0) {
          setDriverError(t('errors.noDriversFound'));
        } else {
          setDrivers(formattedDrivers);
          setFilteredDrivers(formattedDrivers);
        }
      } catch (err) {
        setDriverError(t('errors.fetchDriversFailed', { message: err.message }));
      } finally {
        setLoadingDrivers(false);
      }
    };
    fetchDrivers();
  }, [t]);

  useEffect(() => {
    setFilteredDrivers(
      drivers.filter(
        (driver) =>
          driver.name.toLowerCase().includes(search.toLowerCase()) ||
          driver.id.includes(search)
      )
    );
  }, [search, drivers]);

  const handleInputChange = (e, field, index = null) => {
    if (index !== null) {
      const newIntermediates = [...formData.intermediateDestinations];
      newIntermediates[index][field] = e.target.value;
      setFormData({ ...formData, intermediateDestinations: newIntermediates });
    } else {
      setFormData({ ...formData, [field]: e.target.value });
    }
  };

  const addIntermediateStop = () => {
    setFormData({
      ...formData,
      intermediateDestinations: [...formData.intermediateDestinations, { destination: '', time: '', lat: '', lng: '' }],
    });
  };

  const openMapModal = (type, index = null) => {
    setMapType(type);
    setMapIndex(index);
    setShowMapModal(true);
  };

  useEffect(() => {
    if (showMapModal && mapRef.current) {
      const map = L.map(mapRef.current).setView([51.505, -0.09], 13); // Default to London
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      const onMapClick = (e) => {
        if (markerRef.current) {
          map.removeLayer(markerRef.current);
        }
        markerRef.current = L.marker([e.latlng.lat, e.latlng.lng]).addTo(map);
      };

      map.on('click', onMapClick);

      return () => {
        map.off('click', onMapClick);
        map.remove();
      };
    }
  }, [showMapModal]);

  const saveMapCoordinates = () => {
    if (markerRef.current) {
      const { lat, lng } = markerRef.current.getLatLng();
      if (mapType === 'origin') {
        setFormData({
          ...formData,
          originLat: lat.toString(),
          originLng: lng.toString(),
        });
      } else if (mapType === 'destination') {
        setFormData({
          ...formData,
          destinationLat: lat.toString(),
          destinationLng: lng.toString(),
        });
      } else if (mapType === 'intermediate' && mapIndex !== null) {
        const newIntermediates = [...formData.intermediateDestinations];
        newIntermediates[mapIndex] = {
          ...newIntermediates[mapIndex],
          lat: lat.toString(),
          lng: lng.toString(),
        };
        setFormData({ ...formData, intermediateDestinations: newIntermediates });
      }
    }
    setShowMapModal(false);
    setMapType('');
    setMapIndex(null);
  };

  // --- UPDATED SUBMIT HANDLER TO SUPPORT MULTIPLE CONTAINERS ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSuccess('');

      // Validate required Global fields
      const requiredFields = [
        'orderId', 'origin', 'originLat', 'originLng', 'destination', 'destinationLat', 'destinationLng',
        'goodsType', 'pickUpDate', 'dropOffDate', 'addOnDate', 'estimateDeliveryDate', 'status'
      ];

      for (const field of requiredFields) {
        if (!formData[field]) {
          toast.error(`${t('orders.' + field)} Required`, { position: "top-right" });
          return; // stop execution on first missing field
        }
      }

      // Validate each Container
      for (let i = 0; i < formData.containers.length; i++) {
        if (!formData.containers[i].containerNumber) {
          toast.error(`${t('orders.containerNumber')} Required for Row ${i + 1}`, { position: "top-right" });
          return;
        }
      }

      // Validate coordinate fields
      const isValidLatitude = (value) => {
        const num = parseFloat(value);
        return !isNaN(num) && isFinite(num) && num >= -90 && num <= 90;
      };

      const isValidLongitude = (value) => {
        const num = parseFloat(value);
        return !isNaN(num) && isFinite(num) && num >= -180 && num <= 180;
      };

      if (!isValidLatitude(formData.originLat) || !isValidLongitude(formData.originLng)) {
        toast.error(t('errors.invalidCoordinates', { field: 'Origin' }), { position: "top-right" });
        return;
      }

      if (!isValidLatitude(formData.destinationLat) || !isValidLongitude(formData.destinationLng)) {
        toast.error(t('errors.invalidCoordinates', { field: 'Destination' }), { position: "top-right" });
        return;
      }

      // Validate intermediate destinations
      const validatedIntermediateDestinations = formData.intermediateDestinations.map((stop, index) => {
        // Skip validation if empty row and not the first one, or strictly validate
        if (!stop.destination || !stop.time) {
          // If it's the default single empty row and user didn't fill it, we might ignore or throw error.
          // Let's check if it has data.
          if (stop.destination === '' && stop.time === '' && formData.intermediateDestinations.length === 1) {
            return null; // ignore empty default
          }
          toast.error(`Intermediate Stop ${index + 1} is incomplete`, { position: "top-right" });
          throw new Error('Validation failed');
        }

        if (!isValidLatitude(stop.lat) || !isValidLongitude(stop.lng)) {
          toast.error(`Invalid coordinates for Intermediate Stop ${index + 1}`, { position: "top-right" });
          throw new Error('Validation failed');
        }

        return {
          destination: stop.destination,
          time: stop.time,
          coordinates: {
            type: 'Point',
            coordinates: [parseFloat(stop.lng), parseFloat(stop.lat)]
          }
        };
      }).filter(Boolean);

      // Loop through containers and send 1-by-1 to backend
      const apiPromises = formData.containers.map((container) => {
        // Prepare submission data for THIS container
        const submissionData = {
          ...formData,
          // Overwrite global fields with container specific ones
          containerNumber: container.containerNumber,
          containerType: container.containerType,
          sealNumber: container.sealNumber,
          weight: container.weight,
          noOfPallets: container.noOfPallets,
          containerComments: container.containerComments,

          // Calculated fields
          currentLocation: { type: 'Point', coordinates: [parseFloat(formData.originLng), parseFloat(formData.originLat)] },
          destinationLocation: { type: 'Point', coordinates: [parseFloat(formData.destinationLng), parseFloat(formData.destinationLat)] },
          intermediateDestinations: validatedIntermediateDestinations.length > 0 ? validatedIntermediateDestinations : undefined,

          // Remove the array from the payload sent to backend
          containers: undefined
        };

        return addShipment(submissionData);
      });

      // Execute all requests
      await Promise.all(apiPromises);

      toast.success(t('orders.createShipmentSuccess'), { position: "top-right" });

      const shipmentData = await getAllShipment({ page: currentPage, limit: 10 ,status:'Pending'});
      const shipmentDatas = shipmentData?.docs;
      let filteredClients = shipmentDatas

      // 3. Conditional Filtering Logic
      if (userProfile?.aiPackageId) {
        // If AI Package exists -> Show ALL (No Filter)
        filteredClients = shipmentDatas; // No filtering, 
      } else {
        // Else -> Filter by 'Dispax'
        filteredClients = shipmentDatas.filter(client => client?.companyType === 'Dispax');
      }




      setShipments(filteredClients || []);
      setTotalPages(shipmentData.totalPages || 1);
      setTotalDocs(shipmentData.totalDocs || 0);
      setHasPrevPage(shipmentData.hasPrevPage || false);
      setHasNextPage(shipmentData.hasNextPage || false);

      openSuccessModal();
      setTimeout(() => {
        setShowModal(false);
        // Reset form to default state with 1 empty container
        setFormData({
          importExportType: 'import',
          orderId: '',
          origin: '',
          originLat: '',
          originLng: '',
          destination: '',
          destinationLat: '',
          destinationLng: '',
          description: '',
          goodsType: '',
          pickUpDate: '',
          dropOffDate: '',
          pickUpHours: '',
          dropOffHours: '',
          companyType: "Dispax",
          containers: [{
            containerNumber: '', containerType: '', sealNumber: '', weight: '', noOfPallets: '', containerComments: ''
          }],
          length: '',
          commodity: '',
          intermediateDestinations: [{ destination: '', time: '', lat: '', lng: '' }],
          terminal: '',
          routeNotes: '',
          driverId: '',
          vehicleNumber: '',
          driverContactNumber: '',
          currentLocation: { type: 'Point', coordinates: [0, 0] },
          destinationLocation: { type: 'Point', coordinates: [0, 0] },
          addOnDate: '',
          estimateDeliveryDate: '',
          portName: '',
          ticketNumber: '',
          bookingNumber: '',
          sl: '',
          price: '',
          isTracking: true,
          status: '',
        });
      }, 1000);

    } catch (err) {
      if (err.message !== 'Validation failed') {
        toast.error(err.message || t('orders.createShipmentFailed'), { position: "top-right" });
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !buttonRef2.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(e.target) &&
        !buttonRef3.current.contains(e.target)
      ) {
        setShowDropdown2(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCalendarToggle = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setCalendarPosition({
        top: rect.height + 5,
        left: 0,
      });
    }
    setShowCalendar((prev) => !prev);
  };

  const toggleRegion = (region) => {
    setSelectedRegions(prev =>
      prev.includes(region)
        ? prev.filter(r => r !== region)
        : [...prev, region]
    );
  };

  const toggleStatus = (status) => {
    setSelectedStatuses(prev =>
      prev.includes(status)
        ? prev.filter(s => s !== status)
        : [...prev, status]
    );
  };

  const openSuccessModal = () => {
    setShowModal(false);
    setIsSuccessModalOpen(true);
  };

  // fetch shipping lines
  useEffect(() => {
    const fetchShippingLines = async () => {
      try {
        const lines = await getShippingLineList();
        console.log("Shipping Lines:", lines);
        setShippingLines(lines || []);
      } catch (error) {
        console.error("Error fetching shipping lines:", error);
      }
    };

    fetchShippingLines();
  }, []);

  const handleOpenModal = (shipmentId) => {
    setSelectedShipmentId(shipmentId);
    setShowSealModal(true);
  };

  const resetFilters = () => {
    setSelectedRegions([]);
    setSelectedStatuses([]);
    setSelectedDates([]);
    setCurrentPage(1);
  };

  useEffect(() => {
    console.log("userProfile 724", userProfile);

    const fetchShipments = async () => {
      try {
        setLoading(true);

        const params = {
           page: currentPage,
        limit: 10,
        status: "Pending",   // 👈 important
        };

        if (selectedStatuses.length > 0) {
          params.status = selectedStatuses;
        }

        if (selectedRegions.length > 0) {
          params.origin = selectedRegions;
        }

        if (selectedDates.length > 0) {
          params.startDate = selectedDates[0]
            .toISOString()
            .split("T")[0];
        }

        const data = await getAllShipment(params);

        let docs = data?.docs || [];

        // 🔐 AI package condition
        if (userProfile?.isAiPackageExpired === false) {
          // AI package NOT active → only Dispax
          docs = docs.filter(
            (item) => item?.companyType === "Dispax"
          );
        }
        // AI package ACTIVE (true) → no filter

        setShipments(docs);
        setTotalPages(data?.totalPages || 1);
        setTotalDocs(docs.length);
        setHasPrevPage(data?.hasPrevPage || false);
        setHasNextPage(data?.hasNextPage || false);
      } catch (err) {
        setError(t("errors.fetchShipmentsFailed"));
      } finally {
        setLoading(false);
      }
    };

    fetchShipments();
  }, [
    currentPage,
    selectedDates,
    selectedRegions,
    selectedStatuses,
    userProfile?.isAiPackageExpired,
    t,
  ]);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      const data = await getAllShipment({ limit: 1000 }); // Fetch a large number to get all options
      if (data.docs) {
        const origins = [...new Set(data.docs.map(shipment => shipment.origin))];
        const destinations = [...new Set(data.docs.map(shipment => shipment.destination))];
        const allLocations = [...new Set([...origins, ...destinations])].filter(Boolean);
        setUniqueLocations(allLocations);

        const statuses = [...new Set(data.docs.map(shipment => shipment.status))].filter(Boolean);
        setUniqueStatuses(statuses);
      }
    };
    fetchFilterOptions();
  }, []);

  const handlePrevPage = () => {
    if (hasPrevPage) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNextPage = () => {
    if (hasNextPage) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handleInputChanges = (e, index = null, dispatchType) => {
    const { name, value } = e.target;

    setFormDatas(prev => {
      const updatedForm = { ...prev };
      const lowerDispatchType = dispatchType?.toLowerCase();

      if (!lowerDispatchType || !updatedForm[lowerDispatchType]) {
        console.warn("Invalid dispatchType:", dispatchType);
        return prev;
      }

      if (name.startsWith('intermediateDestinations')) {
        const [, idx, subField] = name.split('.');
        const destinationIndex = parseInt(idx);

        const newIntermediates = [...(updatedForm[lowerDispatchType].intermediateDestinations || [])];

        if (!newIntermediates[destinationIndex]) {
          newIntermediates[destinationIndex] = { destination: '', time: '', stopType: '' };
        }

        newIntermediates[destinationIndex][subField] = value || '';
        updatedForm[lowerDispatchType].intermediateDestinations = newIntermediates;

      } else if (name.startsWith('containers.')) {
        const [, idx, subField] = name.split('.');
        const containerIndex = parseInt(idx);

        const newContainers = [...(updatedForm.export?.containers || [])];
        if (!newContainers[containerIndex]) newContainers[containerIndex] = {};
        newContainers[containerIndex][subField] = value || '';
        updatedForm.export.containers = newContainers;

      } else {
        updatedForm[lowerDispatchType][name] = value || '';
      }

      return updatedForm;
    });
  };

  const addIntermediateDestination = (dispatchType) => {
    const lowerDispatchType = dispatchType.toLowerCase();
    setFormDatas(prev => ({
      ...prev,
      [lowerDispatchType]: {
        ...prev[lowerDispatchType],
        intermediateDestinations: [
          ...prev[lowerDispatchType].intermediateDestinations,
          { destination: '', time: '', stopType: '' },
        ],
      },
    }));
  };

  const removeIntermediateDestination = (index, dispatchType) => {
    const lowerDispatchType = dispatchType.toLowerCase();
    setFormDatas(prev => {
      const newStops = prev[lowerDispatchType].intermediateDestinations.filter((_, i) => i !== index);
      return {
        ...prev,
        [lowerDispatchType]: {
          ...prev[lowerDispatchType],
          intermediateDestinations: newStops,
        },
      };
    });
  };

  function removeEmpty(obj) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, v]) => {
          if (v === null || v === undefined) return false;
          if (typeof v === 'string' && v.trim() === '') return false;
          if (Array.isArray(v) && v.length === 0) return false;
          if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return false;
          return true;
        })
        .map(([k, v]) => {
          if (typeof v === 'object' && !Array.isArray(v)) {
            return [k, removeEmpty(v)];
          }
          if (Array.isArray(v)) {
            return [
              k,
              v.map(item => (typeof item === 'object' ? removeEmpty(item) : item))
                .filter(item => {
                  if (item === null || item === undefined) return false;
                  if (typeof item === 'string' && item.trim() === '') return false;
                  if (typeof item === 'object' && Object.keys(item).length === 0) return false;
                  return true;
                }),
            ];
          }
          return [k, v];
        })
    );
  }
  const isValidDate = (dateString) => {
    if (!dateString) return true;
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regex)) return false;
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date);
  };

  const handleSubmits = async (e, dispatchType) => {
    e.preventDefault();
    if (
      formDatas[dispatchType.toLowerCase()].loadDate &&
      !isValidDate(formDatas[dispatchType.toLowerCase()].loadDate)
    ) {
      Swal.fire(t('errors.error'), t('errors.invalidDate'), 'error');
      return;
    }
    try {
      let shipmentsPayload = [];
      let shipmentId = '';

      const dispatchMode = formDatas[selectedType.toLowerCase()]?.dispatchMode;

      console.log('dispatchMode', dispatchMode)
      let payload = {
        shipmentId,
        shipments: shipmentsPayload,
        dispatchType: selectedShipping,

        dispatchMode: dispatchMode,
        importExportType:
          (dispatchType === 'Import' || dispatchType === 'Export'
            ? dispatchType.toLowerCase()
            : 'Disptach'),

        shippingMethod: formDatas[dispatchType.toLowerCase()].shippingMethod,
        shippingMethod1: formDatas[dispatchType.toLowerCase()].shippingMethod1,
        status: 'Pending',
        commodity: formDatas[dispatchType.toLowerCase()].commodity,
        origin: formDatas[dispatchType.toLowerCase()].loadAddress || 'Los Angeles, CA',
        size: formDatas[dispatchType.toLowerCase()].size || null,
        returnFull: formDatas[dispatchType.toLowerCase()].returnFull,
        loadTime: formDatas[dispatchType.toLowerCase()].loadTime,
        loadAddress: formDatas[dispatchType.toLowerCase()].loadAddress,
        loadDate: formDatas[dispatchType.toLowerCase()].loadDate
          ? new Date(formDatas[dispatchType.toLowerCase()].loadDate).toISOString()
          : null,
        trailerNumber:
          dispatchType === 'LTL' || dispatchType === 'FTL'
            ? formDatas[dispatchType.toLowerCase()].trailerNumber
            : null,
        bookingNumber: formDatas[dispatchType.toLowerCase()].bookingNumber,
        destination: formDatas[dispatchType.toLowerCase()].destination,
        pinNumber: formDatas[dispatchType.toLowerCase()].pinNumber,
        importLocation: formDatas[dispatchType.toLowerCase()].importLocation,
        sealNumber: formDatas[dispatchType.toLowerCase()].sealNumber,

        poNumber: formDatas[dispatchType.toLowerCase()].poNumber,
        flatBeds: formDatas[dispatchType.toLowerCase()].flatBeds,
        sl: formDatas[dispatchType.toLowerCase()].sl,
        intermediateDestinations: formDatas[
          dispatchType.toLowerCase()
        ].intermediateDestinations
          .map(stop => ({
            destination: stop.destination,
            time: stop.time,
            stopType: stop.stopType || '',
          }))
          .filter(stop => stop.destination && stop.time),
      };

      payload = removeEmpty(payload);

      await addDispatchShipment(payload);
      Swal.fire(
        t('orders.successfully'),
        t(`orders.create${dispatchType}Dispatch`),
        'success'
      );
      setShowLTLModal(false);
      setShowFTLModal(false);
      setFormDatas(prev => ({
        ...prev,
        [dispatchType.toLowerCase()]: {
          shippingMethod: '',
          shippingMethod1: '',
          pickEmpty: '',
          sl: '',
          size: '',
          loadDate: '',
          loadTime: '',
          loadAddress: '',
          commodity: '',
          returnFull: '',
          trailerNumber: '',
          bookingNumber: '',
          destination: '',
          pinNumber: '',
          importLocation: '',
          poNumber: '',
          flatBeds: '',
          dispatchMode: '',
          intermediateDestinations: [
            { destination: '', time: '', stopType: '' },
          ],
          containers:
            dispatchType === 'Export'
              ? [
                {
                  bookingNumber: '',
                  size: '',
                  pickEmpty: '',
                  commodity: '',
                  returnFull: '',
                },
              ]
              : undefined,
        },
      }));
      setSelectedDriver(null);
      setSelectedType('');
      setSelectedShipping('');
      const shipmentsData = await getAllShipment();
      setShipments(shipmentsData.docs);
    } catch (error) {
      console.error(`Error creating ${dispatchType} dispatch:`, error);
      let errorMessage = t('errors.createDispatchFailed', { dispatchType });
      if (error.response?.data?.errors) {
        errorMessage = Object.entries(error.response.data.errors)
          .map(([field, err]) => `${field}: ${err.message || err}`)
          .join('\n');
      } else if (error.message) {
        errorMessage = t('errors.error', { message: error.message });
      }
      Swal.fire(t('errors.error'), errorMessage, 'error');
    }
  };

  const handleOpenSealModal = (id) => {
    setSelectedShipmentId(id);
    setShowSealModal(true);
  };

  const refreshShipments = () => {
    console.log("Shipment list refreshed after seal update.");
  };

  return (
    <div className="text-white px-1 sm:px-4">
      <div className="flex flex-col sm:flex-row items-center justify-between mb-6">
        <h1 className="text-2xl sm:text-xl font-semibold mb-4 sm:mb-0">
          {t('orders.title')}
        </h1>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-end mb-6 gap-4">
        {/* <div className="flex flex-col sm:flex-row items-center bg-[#10194E] rounded-xl shadow-md w-full sm:w-auto">
          <div className="flex items-center gap-2 px-4 py-3 sm:py-5 border-b sm:border-b-0 sm:border-r border-[#1E2A60] text-white w-full sm:w-auto">
            <FiFilter className="text-lg sm:text-base" />
            <span className="text-sm">{t('orders.filterBy')}</span>
          </div>

          <div className="relative w-full sm:w-auto">
            <button
              ref={buttonRef}
              onClick={handleCalendarToggle}
              className="px-4 py-3 sm:py-5 text-sm border-b sm:border-b-0 sm:border-r border-[#1E2A60] bg-transparent text-white w-full sm:w-auto text-left sm:text-center"
            >
              {selectedDates.length > 0
                ? selectedDates.map((date) => format(date, "PP", { locale: selectedLanguage === 'Spanish' ? es : undefined })).join(", ")
                : t('orders.date')}
            </button>
            {showCalendar && (
              <div
                ref={calendarRef}
                className="absolute left-0 sm:left-9 sm:-translate-x-24 p-4 shadow-lg rounded z-50 w-[90%] sm:w-auto"
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                }}
              >
                <DayPicker
                  mode="multiple"
                  selected={selectedDates}
                  onSelect={setSelectedDates}
                  locale={selectedLanguage === 'Spanish' ? es : undefined}
                  footer={
                    <div className="pt-4">
                      <div className="flex justify-start">
                        <span className="text-xs sm:text-sm text-gray-400">
                          {t('orders.multipleDates')}
                        </span>
                      </div>
                    </div>
                  }
                />
              </div>
            )}
          </div>

          <div className="relative w-full sm:w-auto">
            <button
              ref={buttonRef2}
              onClick={() => setShowDropdown(!showDropdown)}
              className="bg-transparent text-white px-4 py-3 sm:py-5 text-sm border-b sm:border-b-0 sm:border-r border-[#1E2A60] outline-none w-full sm:w-auto text-left sm:text-center"
            >
              {t('orders.location')}
            </button>
            {showDropdown && (
              <div
                ref={dropdownRef}
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                }}
                className="absolute left-0 sm:left-1/2 sm:-translate-x-1/2 top-full mt-2 w-[90%] sm:w-80 text-white rounded-2xl p-4 sm:p-6 z-50 shadow-lg"
              >
                <h2 className="text-base sm:text-lg font-semibold mb-4">
                  {t('orders.location')}
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 mb-4">
                  {uniqueLocations.map((location) => (
                    <button
                      key={location}
                      onClick={() => toggleRegion(location)}
                      className={`px-2 sm:px-3 py-1 sm:py-2 rounded-full border transition-all text-xs sm:text-sm ${selectedRegions.includes(location)
                        ? "bg-white text-black font-semibold"
                        : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                        }`}
                    >
                      {location}
                    </button>
                  ))}
                </div>
                <p className="text-xs sm:text-sm text-gray-300 mb-3">
                  {t('orders.multipleLocations')}
                </p>
              </div>
            )}
          </div>

          <div className="relative w-full sm:w-auto">
            <button
              ref={buttonRef3}
              onClick={() => setShowDropdown2(!showDropdown2)}
              className="bg-transparent text-white px-4 py-3 sm:py-5 text-sm border-b sm:border-b-0 sm:border-r border-[#1E2A60] outline-none w-full sm:w-auto text-left sm:text-center"
            >
              {t('orders.statusLabel')}
            </button>
            {showDropdown2 && (
              <div
                ref={dropdownRef2}
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                }}
                className="absolute left-0 sm:left-1/2 sm:-translate-x-1/2 top-full mt-2 w-[90%] sm:w-80 text-white rounded-2xl p-4 sm:p-6 z-50 shadow-lg"
              >
                <h2 className="text-base sm:text-lg font-semibold mb-4">
                  {t('orders.selectOrderStatus')}
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 mb-4">
                  {uniqueStatuses.map((status) => (
                    <button
                      key={status}
                      onClick={() => toggleStatus(status)}
                      className={`px-2 sm:px-3 py-1 sm:py-2 rounded-full border transition-all text-xs sm:text-sm ${selectedStatuses.includes(status)
                        ? "bg-white text-black font-semibold"
                        : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                        }`}
                    >
                      {t(`orders.status.${status.toLowerCase()}`, { defaultValue: status })}
                    </button>
                  ))}
                </div>
                <p className="text-xs sm:text-sm text-gray-300 mb-3">
                  {t('orders.multipleOrderStatus')}
                </p>
              </div>
            )}
          </div>
          <button
            onClick={resetFilters}
            className="flex items-center gap-1 px-4 py-3 sm:py-5 text-sm text-orange-400 hover:underline w-full sm:w-auto text-left sm:text-center"
          >
            <FiRotateCw className="text-sm" />
            {t('orders.resetFilter')}
          </button>
        </div> */}

        <button
          onClick={() => setShowModal(true)}
          className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] hover:opacity-90 px-4 sm:px-5 py-2 rounded-xl text-white font-medium flex items-center gap-2 shadow-md w-full sm:w-auto mt-4 sm:mt-0"
        >
          <FiPlus className="text-md sm:text-base" />
          {t('orders.createNewDispatch')}
        </button>
      </div>

      {showModal && (
 <CreateContainerModal
    // 1. Form State
    formData={formData}
    setFormData={setFormData}
    
    // 2. Input Handlers
    handleInputChange={handleInputChange}
    handleContainerChange={handleContainerChange}
    
    // 3. Container Row Actions
    addContainerRow={addContainerRow}
    removeContainerRow={removeContainerRow}
    
    // 4. Form Submit Action
    onSubmit={handleSubmit} // Jo aapka main API call wala function hai
    
    // 5. Modal Close Actions
    onClose={() => setShowModal(false)}
    
    // 6. Navigation/Other Modals Actions
    openFTL={() => {
      setShowModal(false);
      setShowFTLModal(true);
      setSelectedShipping("FTL");
      setSelectedType("FTL");
      setFormData((prev) => ({ ...prev, ftl: { ...prev.ftl, shippingMethod: "FTL" } }));
    }}
    openLTL={() => {
      setShowModal(false);
      setShowLTLModal(true);
      setSelectedShipping("LTL");
      setSelectedType("LTL");
      setFormData((prev) => ({ ...prev, ftl: { ...prev.ftl, shippingMethod: "LTL" } }));
    }}
    
    // 7. Map Open Action
    openMap={(type, index = null) => {
      // Ye function wahi hai jo aapne parent mein banaya tha
      openMapModal(type, index);
    }}
    />
      )}

      {showMapModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div
            className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-[90%] sm:w-[80%] max-w-[480px] h-[400px]"
            style={{
              background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
            }}
          >
            <button
              onClick={() => setShowMapModal(false)}
              className="absolute top-2 right-4 text-2xl sm:text-xl font-bold"
            >
              ×
            </button>
            <h2 className="text-lg font-bold mb-4">
              {t(`orders.select${mapType.charAt(0).toUpperCase() + mapType.slice(1)}Location`)}
            </h2>
            <div ref={mapRef} style={{ height: '300px', width: '100%' }}></div>
            <div className="flex justify-center mt-4">
              <button
                onClick={saveMapCoordinates}
                className="w-full py-2 bg-[#6F1AFF] text-white rounded-md text-sm hover:opacity-90"
              >
                {t('orders.saveLocation')}
              </button>
            </div>
          </div>
        </div>
      )}

      {isSuccessModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-[#0F0D2E] p-6 sm:p-8 rounded-2xl w-full max-w-[90%] sm:max-w-md text-center" style={{ backdropFilter: 'blur(42.7px)' }}>
            <h2 style={{ fontFamily: "Poppins" }} className="text-[24px] sm:text-[30px] font-bold text-white leading-tight">
              {t('orders.assigned')} <span className="text-[30px] sm:text-[45px] text-[#6F1AFF]">{t('orders.successfully')}</span>
            </h2>
            <p className="text-xs sm:text-sm text-gray-400 mb-4 sm:mb-6 mt-1">
              {t('orders.successMessage')}
            </p>
            <div className="flex justify-center mb-4 sm:mb-6">
              <img src={check} alt={t('alt.checkmark')} className="w-[150px] sm:w-[197px] h-[120px] sm:h-[156px]" />
            </div>
            <button
              onClick={() => setIsSuccessModalOpen(false)}
              className="w-full py-2 sm:py-3 bg-[#6F1AFF] text-white rounded-xl hover:opacity-90 transition font-medium text-sm"
            >
              {t('orders.ok')}
            </button>
          </div>
        </div>
      )}

      <div className="overflow-x-auto bg-[#1D2461] rounded-lg">
        <table className="w-full table-auto text-sm text-left min-w-[640px]">
          <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[12px] sm:text-[14px]">
            <tr>
              <th className="p-2 sm:p-4"></th>
              <th className="p-2 sm:p-4">{t("orders.containerId")}</th>
              <th className="p-2 sm:p-4">{t("orders.purchaseOrderNo")}</th>
              <th className="p-2 sm:p-4">{t("orders.originDestination")}</th>
              <th className="p-2 sm:p-4">{t("orders.importExportType.import")}</th>
              <th className="p-2 sm:p-4">{t("orders.sealNumber")}</th>
              <th className="p-2 sm:p-4">{t("orders.statusLabel")}</th>
              <th className="p-2 sm:p-4">{t("orders.actions")}</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr className="border-t border-[#2A2A4D]">
                <td colSpan="9" className="p-2 sm:p-4 text-center">
                  <div className="flex justify-center">
                    <div className="w-6 h-6 border-4 border-t-[#707EFF] border-[#2A2A4D] rounded-full animate-spin"></div>
                  </div>
                </td>
              </tr>
            ) : shipments.length > 0 ? (
              shipments.map((row) => (
                <tr key={row._id} className="border-t border-[#2A2A4D]">
                  <td className="p-2 sm:p-4">
                    <input type="checkbox" />
                  </td>
                  <td className="p-2 sm:p-4 text-xs sm:text-sm">{row.Id}</td>
                  <td className="p-2 sm:p-4 text-xs sm:text-sm">{row.orderId}</td>
                  <td className="p-2 sm:p-4 text-xs sm:text-sm">
                    {row.origin} → {row.destination}
                  </td>
                  <td className="p-2 sm:p-4 text-xs sm:text-sm">
                    {t(
                      `orders.importExportType.${row?.importExportType?.toLowerCase?.() ?? "unknown"}`,
                      { defaultValue: row?.importExportType ?? "N/A" }
                    )}
                  </td>

                  <td className="p-2 sm:p-4 text-xs sm:text-sm">
                    {row.sealNumber ? row.sealNumber : t("orders.noSealNumber")}
                  </td>

                  <td className="p-2 sm:p-4">
                    <span className="inline-flex items-center gap-2 text-xs sm:text-sm">
                      <span
                        className={`w-2 sm:w-3 h-2 sm:h-3 rounded-full ${statusColors[row.status] || "bg-gray-500"
                          }`}
                      ></span>
                      {t(`orders.status.${row.status.toLowerCase()}`, {
                        defaultValue: row.status,
                      })}
                    </span>
                  </td>

                  <td className="p-2 sm:p-4 flex flex-col sm:flex-row gap-2">
                    <button
                      onClick={() => handleViewShipment(row._id)}
                      className="bg-[#00B69B] text-white px-3 sm:px-4 py-1 rounded-2xl hover:bg-blue-600 text-xs sm:text-sm"
                    >
                      {t("orders.view")}
                    </button>

                    <button
                      onClick={() => handleOpenSealModal(row._id)}
                      className="bg-[#6F1AFF] text-white px-3 sm:px-4 py-1 rounded-2xl hover:opacity-90 text-xs sm:text-sm"
                    >
                      {row.sealNumber ? t("orders.updateSealNumberButton", "Update Seal Number") : t("orders.addSealNumberButton", "Add Seal Number")}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="border-t border-[#2A2A4D]">
                <td colSpan="9" className="p-2 sm:p-4 text-center text-xs sm:text-sm">
                  {t("orders.noShipmentsFound")}
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm text-gray-400 p-2 sm:p-4">
          <div className="mb-2 sm:mb-0">
            {t('orders.showing', {
              start: shipments.length > 0 ? (currentPage - 1) * 10 + 1 : 0,
              end: shipments.length > 0 ? Math.min(currentPage * 10, totalDocs) : 0,
              total: totalDocs,
            })}
          </div>
          <div className="flex gap-2 sm:gap-4">
            <button
              onClick={handlePrevPage}
              disabled={!hasPrevPage}
              className={`px-3 sm:px-4 py-1 sm:py-2 rounded-md text-xs sm:text-sm ${hasPrevPage ? 'bg-[#00B69B] text-white hover:bg-blue-600' : 'bg-gray-500 text-gray-300 cursor-not-allowed'}`}
            >
              {t('orders.previous')}
            </button>
            <button
              onClick={handleNextPage}
              disabled={!hasNextPage}
              className={`px-3 sm:px-4 py-1 sm:py-2 rounded-md text-xs sm:text-sm ${hasNextPage ? 'bg-[#00B69B] text-white hover:bg-blue-600' : 'bg-gray-500 text-gray-300 cursor-not-allowed'}`}
            >
              {t('orders.next')}
            </button>
          </div>
        </div>
      </div>

      {showModal2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div
            className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-[90%] sm:w-[80%] max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
            style={{
              background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
            }}
          >
            <button
              onClick={() => {
                setShowModal2(false);
                setSelectedShipment(null);
                setFormData({
                  Id: '',
                  orderId: '',
                  noOfPallets: '',
                  goodsType: '',
                  addOnDate: '',
                  estimateDeliveryDate: '',
                  store: '',
                  estimatedTimeAccurate: '',
                  status: '',
                  intermediateDestinations: '',
                });
              }}
              className="absolute top-2 right-4 text-2xl sm:text-xl font-bold"
            >
              ×
            </button>

            <h2 className="text-xl sm:text-lg font-bold mb-4">
              {t('orders.detailedContainerView')}
            </h2>

            {modalLoading ? (
              <div className="flex justify-center">
                <div className="w-6 h-6 border-4 border-t-[#707EFF] border-[#2A2A4D] rounded-full animate-spin"></div>
              </div>
            ) : (
              <form className="space-y-3 sm:space-y-4" onSubmit={handleUpdateShipment}>
                <h3 className="text-sm text-cyan-400 font-semibold">
                  {t('orders.shipmentOverview')}
                </h3>
                <div>
                  <label className="text-sm block mb-1">
                    {t('orders.containerId')}
                  </label>
                  <input
                    name="Id"
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                    value={formData.Id}
                    onChange={handleInputChange2}
                    placeholder={t('orders.containerIdPlaceholder')}
                  />
                </div>
                <div>
                  <label className="text-sm block mb-1">
                    {t('orders.orderId')}
                  </label>
                  <input
                    name="orderId"
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                    value={formData.orderId}
                    onChange={handleInputChange2}
                    placeholder={t('orders.orderIdPlaceholder')}
                  />
                </div>
                <div>
                  <label className="text-sm block mb-1">
                    {t('orders.noOfPallets')}
                  </label>
                  <input
                    name="noOfPallets"
                    type="number"
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                    value={formData.noOfPallets}
                    onChange={handleInputChange2}
                    placeholder={t('orders.noOfPalletsPlaceholder')}
                  />
                </div>
                <div>
                  <label className="text-sm block mb-1">
                    {t('orders.goodsType')}
                  </label>
                  <select
                    name="goodsType"
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                    value={formData.goodsType}
                    onChange={handleInputChange2}
                  >
                    <option value="">
                      {t('orders.selectGoodsType')}
                    </option>
                    <option value="Electronics">
                      {t('orders.goodsTypeOptions.electronics')}
                    </option>
                    <option value="Textile">
                      {t('orders.goodsTypeOptions.textile')}
                    </option>
                    <option value="Food">
                      {t('orders.goodsTypeOptions.food')}
                    </option>
                  </select>
                </div>
                <div>
                  <label className="text-sm block mb-1">
                    {t('orders.addedOn')}
                  </label>
                  <input
                    name="addOnDate"
                    type="datetime-local"
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                    value={formData.addOnDate}
                    onChange={handleInputChange2}
                  />
                </div>
                <div>
                  <label className="text-sm block mb-1">
                    {t('orders.estimatedDeliveryDate')}
                  </label>
                  <input
                    name="estimateDeliveryDate"
                    type="datetime-local"
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                    value={formData.estimateDeliveryDate}
                    onChange={handleInputChange2}
                  />
                </div>
                <div>
                  <label className="text-sm block mb-1">
                    {t('Status')}
                  </label>
                  <select
                    name="status"
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                    value={formData.status}
                    onChange={handleInputChange2}
                  >
                    <option value="">
                      {t('orders.selectStatus')}
                    </option>
                    <option value="Pending">
                      {t('orders.status.pending')}
                    </option>
                    <option value="In Transit">
                      {t('orders.status.inTransit')}
                    </option>
                    <option value="Delivered">
                      {t('orders.status.delivered')}
                    </option>
                  </select>
                </div>
                <h3 className="text-sm text-cyan-400 font-semibold mt-3 sm:mt-4">
                  {t('orders.stopsList')}
                </h3>
                <div>
                  <label className="text-sm block mb-1">
                    {t('orders.stopsList')}
                  </label>
                  <textarea
                    name="intermediateDestinations"
                    rows="4"
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                    value={formData.intermediateDestinations}
                    onChange={handleInputChange2}
                    placeholder={t('orders.stopsListPlaceholder')}
                  />
                </div>
                <button
                  type="submit"
                  className="w-full py-2 sm:py-3 bg-[#6F1AFF] text-white rounded-xl hover:opacity-90 transition font-medium text-sm"
                  disabled={modalLoading}
                >
                  {t('orders.update')}
                </button>
              </form>
            )}
          </div>
        </div>
      )}


      {showFTLModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center p-4">
          <div
            className="rounded-xl shadow-xl text-white p-6 relative w-full max-w-md max-h-[90vh] overflow-y-auto hide-scrollbar"
            style={{ background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)" }}
          >
            <button
              onClick={() => setShowFTLModal(false)}
              className="absolute top-4 right-4 text-2xl font-bold hover:text-gray-300"
              aria-label={t('alt.closeFTLModal')}
            >
              <FiX />
            </button>

            <h2 className="text-xl font-bold mb-4">{t('orders.createFTLDispatch')}</h2>

            <form onSubmit={(e) => handleSubmits(e, 'FTL')} className="space-y-4">

              {/* Dispatch Mode */}
              <div>
                <label className="text-sm block mb-1">{t('orders.dispatchMode')}</label>
                <select
                  name="dispatchMode"
                  value={formDatas.ftl.dispatchMode}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                >
                  <option value="">{t('orders.selectDispatchModePlaceholder')}</option>
                  <option value="Pick-up Load">{t('orders.pickUpLoad')}</option>
                  <option value="Delivery">{t('orders.delivery')}</option>
                </select>
              </div>

              {/* Shipping Method */}
              <div>
                <label className="text-sm block mb-1">{t('orders.shippingMethod')}</label>
                <input
                  type="text"
                  name="shippingMethod1"
                  value={formDatas.ftl.shippingMethod1}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.shippingMethodPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Pick Empty */}
              <div>
                <label className="text-sm block mb-1">{t('orders.pickEmpty')}</label>
                <input
                  type="text"
                  name="pickEmpty"
                  value={formDatas.ftl.pickEmpty}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.pickEmptyPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              <div>
                <label className="text-sm block mb-1">{t('orders.sealNumber')}</label>
                <input
                  type="text"
                  name="sealNumber"
                  value={formDatas?.ftl?.sealNumber || ''}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.sealNumber')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.sealNumber')}
                />
              </div>

              {/* Load / Pickup / Delivery Date */}
              <div>
                <label className="text-sm block mb-1">
                  {formDatas.ftl.dispatchMode === "Delivery"
                    ? t('orders.deliveryDate')
                    : formDatas.ftl.dispatchMode === "Pick-up Load"
                      ? t('orders.pickupDate')
                      : t('orders.loadDate')}
                </label>
                <input
                  type="date"
                  name="loadDate"
                  value={formDatas.ftl.loadDate}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Load / Pickup / Delivery Address */}
              <div>
                <label className="text-sm block mb-1">
                  {formDatas.ftl.dispatchMode === "Delivery"
                    ? t('orders.deliveryAddress')
                    : formDatas.ftl.dispatchMode === "Pick-up Load"
                      ? t('orders.pickupAddress')
                      : t('orders.loadAddress')}
                </label>
                <input
                  type="text"
                  name="loadAddress"
                  value={formDatas.ftl.loadAddress}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={
                    formDatas.ftl.dispatchMode === "Delivery"
                      ? t('orders.deliveryAddressPlaceholder')
                      : formDatas.ftl.dispatchMode === "Pick-up Load"
                        ? t('orders.pickupAddressPlaceholder')
                        : t('orders.loadAddressPlaceholder')
                  }
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Destination */}
              <div>
                <label className="text-sm block mb-1">{t('orders.destination')}</label>
                <input
                  type="text"
                  name="destination"
                  value={formDatas.ftl.destination}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.destinationPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Commodity */}
              <div>
                <label className="text-sm block mb-1">{t('orders.commodity')}</label>
                <input
                  type="text"
                  name="commodity"
                  value={formDatas.ftl.commodity}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.commodityPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Return Full */}
              <div>
                <label className="text-sm block mb-1">{t('orders.returnFull')}</label>
                <input
                  type="text"
                  name="returnFull"
                  value={formDatas.ftl.returnFull}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.returnFullPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Trailer Number */}
              <div>
                <label className="text-sm block mb-1">{t('orders.trailerNumber')}</label>
                <input
                  type="text"
                  name="trailerNumber"
                  value={formDatas.ftl.trailerNumber}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.trailerNumberPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Booking Number */}
              <div>
                <label className="text-sm block mb-1">{t('orders.bookingNumber')}</label>
                <input
                  type="text"
                  name="bookingNumber"
                  value={formDatas.ftl.bookingNumber}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.bookingNumberPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Flat Beds */}
              <div>
                <label className="text-sm block mb-1">{t('orders.flatBeds')}</label>
                <input
                  type="text"
                  name="flatBeds"
                  value={formDatas.ftl.flatBeds}
                  onChange={(e) => handleInputChanges(e, null, 'FTL')}
                  placeholder={t('orders.flatBedsPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                />
              </div>

              {/* Intermediate Stops */}
              <div>
                <label className="text-sm block mb-1">{t('orders.intermediateStops')}</label>
                {formDatas.ftl.intermediateDestinations.map((stop, index) => (
                  <div key={index} className="flex gap-2 mb-2">
                    <input
                      type="text"
                      name={`intermediateDestinations.${index}.destination`}
                      value={stop.destination}
                      onChange={(e) => handleInputChanges(e, index, 'FTL')}
                      placeholder={t('orders.stopDestinationPlaceholder', { index: index + 1 })}
                      className="w-full px-3 py-2 rounded bg-white text-black"
                    />
                    <input
                      type="time"
                      name={`intermediateDestinations.${index}.time`}
                      value={stop.time}
                      onChange={(e) => handleInputChanges(e, index, 'FTL')}
                      className="w-full px-3 py-2 rounded bg-white text-black"
                    />
                    <select
                      name={`intermediateDestinations.${index}.stopType`}
                      value={stop.stopType}
                      onChange={(e) => handleInputChanges(e, index, 'FTL')}
                      className="w-full px-3 py-2 rounded bg-white text-black"
                    >
                      <option value="">{t('orders.selectStopType')}</option>
                      <option value="Pick-up Load">{t('orders.pickUpLoad')}</option>
                      <option value="Delivery">{t('orders.delivery')}</option>
                    </select>
                    {formDatas.ftl.intermediateDestinations.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeIntermediateDestination(index, 'FTL')}
                        className="text-red-400 hover:text-red-600"
                      >
                        {t('orders.removeStop')}
                      </button>
                    )}
                  </div>
                ))}
                {formDatas.ftl.intermediateDestinations.length < 15 && (
                  <button
                    type="button"
                    onClick={() => addIntermediateDestination('FTL')}
                    className="text-blue-400 hover:text-blue-600 mt-2"
                  >
                    {t('orders.addStop')}
                  </button>
                )}
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="w-full bg-[#792aff] text-white py-2 rounded-md font-semibold"
                disabled={isLoading}
              >
                {isLoading ? t('dashboard.loading') : t('orders.createFTLDispatch')}
              </button>
            </form>
          </div>
        </div>
      )}

      {showLTLModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center p-4">
          <div
            className="rounded-xl shadow-xl text-white p-6 relative w-full max-w-md max-h-[90vh] overflow-y-auto hide-scrollbar"
            style={{
              background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
            }}
          >
            <button
              onClick={() => setShowLTLModal(false)}
              className="absolute top-4 right-4 text-2xl font-bold hover:text-gray-300"
              aria-label={t('alt.closeLTLModal')}
            >
              <FiX />
            </button>
            <h2 className="text-xl font-bold mb-4">{t('orders.createLTLDispatch')}</h2>
            <form onSubmit={(e) => handleSubmit(e, 'LTL')} className="space-y-4">
              <div>
                <label className="text-sm block mb-1">{t('orders.dispatchMode')}</label>
                <select
                  name="dispatchMode"
                  value={formDatas.ltl.dispatchMode}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.dispatchMode')}
                >
                  <option value="">{t('orders.selectDispatchModePlaceholder')}</option>
                  <option value="Pick-up Load">{t('orders.pickUpLoad')}</option>
                  <option value="Delivery">{t('orders.delivery')}</option>
                </select>
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.shippingMethod')}</label>
                <input
                  type="text"
                  name="shippingMethod1"
                  value={formDatas.ltl.shippingMethod1}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.shippingMethodPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.shippingMethod')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.pickEmpty')}</label>
                <input
                  type="text"
                  name="pickEmpty"
                  value={formDatas.ltl.pickEmpty}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.pickEmptyPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.pickEmpty')}
                />
              </div>

              <div>
                <label className="text-sm block mb-1">{t('orders.sealNumber')}</label>
                <input
                  type="text"
                  name="sealNumber"
                  value={formDatas.ltl.sealNumber}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.sealNumber')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.sealNumber')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.size')}</label>
                <input
                  type="text"
                  name="size"
                  value={formDatas.ltl.size}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.selectSize')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.size')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.loadDate')}</label>
                <input
                  type="date"
                  name="loadDate"
                  value={formDatas.ltl.loadDate}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.loadDate')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.loadTime')}</label>
                <input
                  type="time"
                  name="loadTime"
                  value={formDatas.ltl.loadTime}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.loadTime')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.loadAddress')}</label>
                <input
                  type="text"
                  name="loadAddress"
                  value={formDatas.ltl.loadAddress}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.loadAddressPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.loadAddress')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.destination')}</label>
                <input
                  type="text"
                  name="destination"
                  value={formDatas.ltl.destination}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.destinationPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.destination')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.commodity')}</label>
                <input
                  type="text"
                  name="commodity"
                  value={formDatas.ltl.commodity}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.commodityPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.commodity')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.returnFull')}</label>
                <input
                  type="text"
                  name="returnFull"
                  value={formDatas.ltl.returnFull}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.returnFullPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.returnFull')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.trailerNumber')}</label>
                <input
                  type="text"
                  name="trailerNumber"
                  value={formDatas.ltl.trailerNumber}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.trailerNumberPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.trailerNumber')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.bookingNumber')}</label>
                <input
                  type="text"
                  name="bookingNumber"
                  value={formDatas.ltl.bookingNumber}
                  onChange={(e) => handleInputChange(e, null, 'LTL')}
                  placeholder={t('orders.bookingNumberPlaceholder')}
                  className="w-full px-3 py-2 rounded bg-white text-black"
                  aria-label={t('orders.bookingNumber')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1">{t('orders.intermediateStops')}</label>
                {formDatas.ltl.intermediateDestinations.map((stop, index) => (
                  <div key={index} className="flex gap-2 mb-2">
                    <input
                      type="text"
                      name={`intermediateDestinations.${index}.destination`}
                      value={stop.destination}
                      onChange={(e) => handleInputChange(e, index, 'LTL')}
                      placeholder={t('orders.stopDestinationPlaceholder', { index: index + 1 })}
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      aria-label={t('orders.stopDestinationPlaceholder', { index: index + 1 })}
                    />
                    <input
                      type="time"
                      name={`intermediateDestinations.${index}.time`}
                      value={stop.time}
                      onChange={(e) => handleInputChange(e, index, 'LTL')}
                      placeholder={t('orders.stopTimePlaceholder', { index: index + 1 })}
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      aria-label={t('orders.stopTimePlaceholder', { index: index + 1 })}
                    />
                    <select
                      name={`intermediateDestinations.${index}.stopType`}
                      value={stop.stopType}
                      onChange={(e) => handleInputChange(e, index, 'LTL')}
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      aria-label={t('orders.stopTypePlaceholder', { index: index + 1 })}
                    >
                      <option value="">{t('orders.selectStopType')}</option>
                      <option value="Pick-up Load">{t('orders.pickUpLoad')}</option>
                      <option value="Delivery">{t('orders.delivery')}</option>
                    </select>
                    {formDatas.ltl.intermediateDestinations.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeIntermediateDestination(index, 'LTL')}
                        className="text-red-400 hover:text-red-600"
                        aria-label={t('alt.removeStop', { index: index + 1 })}
                      >
                        {t('orders.removeStop')}
                      </button>
                    )}
                  </div>
                ))}
                {formDatas.ltl.intermediateDestinations.length < 15 && (
                  <button
                    type="button"
                    onClick={() => addIntermediateDestination('LTL')}
                    className="text-blue-400 hover:text-blue-600 mt-2"
                    aria-label={t('alt.addStop')}
                  >
                    {t('orders.addStop')}
                  </button>
                )}
              </div>
              <button
                type="submit"
                className="w-full bg-[#792aff] text-white py-2 rounded-md font-semibold"
                disabled={isLoading}
                aria-label={t('alt.createLTLDispatch')}
              >
                {isLoading ? t('dashboard.loading') : t('orders.createLTLDispatch')}
              </button>
            </form>
          </div>
        </div>
      )}
      <UpdateSealNumberModal
        show={showSealModal}
        onClose={() => setShowSealModal(false)}
        shipmentId={selectedShipmentId}
        onSuccess={refreshShipments}
      />
    </div>
  );
};

export default TotalPendingContainer;
